import { maskCnpj, maskCpf, validDocument, maskCombinedByLength } from '@divipay/br-documents';
import { hideSensInformation as hideCpf } from './cpf';

export function validateDocument(document?: string): boolean {
  return validDocument(document ?? ``);
}

export function maskDocument(
  document?: string,
  options: { hideSensInformation: boolean } = { hideSensInformation: false },
): string {
  if (!document) return ``;

  if (maskCombinedByLength(document) === `cpf`) {
    const masked = maskCpf(document);
    return options.hideSensInformation ? hideCpf(masked) : masked;
  }

  return maskCnpj(document);
}
